/**
 * BookingProgressBarV2.js — IOO-336 Version B
 * Current step title + antd progress bar only.
 * No step circles. No bottom counter.
 *
 * Props:
 *   currentStep              {number}  1–5 from AppointmentPage (5 = Booking completed)
 *   showAppointmentSelection {boolean} disambiguates visual step 3 vs 4
 */
import React from 'react';
import { Progress } from 'antd';
import './BookingProgressBarV2.css';

const STEPS = [
  { id: 1, label: 'Appointment type' },
  { id: 2, label: 'Your preferences' },
  { id: 3, label: 'Choose clinic' },
  { id: 4, label: 'Select a slot' },
  { id: 5, label: 'Payment' },
  { id: 6, label: 'Booking completed' },
];

const TOTAL = STEPS.length;

const getVisualStep = (currentStep, showAppointmentSelection) => {
  if (currentStep === 1) return 1;
  if (currentStep === 2) return 2;
  if (currentStep === 3 && !showAppointmentSelection) return 3;
  if (currentStep === 3 && showAppointmentSelection) return 4;
  if (currentStep === 4) return 5;
  if (currentStep === 5) return 6; // Booking completed — 100%
  return 1;
};

const BookingProgressBarV2 = ({ currentStep, showAppointmentSelection = false, step4SubStep = 1, clinicBookingType = '' }) => {
  if (!currentStep || currentStep < 1 || currentStep > 5) return null;

  const visualStep = getVisualStep(currentStep, showAppointmentSelection);
  let percent = (visualStep / TOTAL) * 100;

  if (currentStep === 4 && step4SubStep === 2) {
    percent += 5;
  }

  let currentLabel = STEPS[visualStep - 1].label;
  if (visualStep === 3) {
    if (clinicBookingType === 'PreferredTime' || clinicBookingType === 'time') {
      currentLabel = 'Choose your appointment time';
    } else {
      currentLabel = 'Choose clinic';
    }
  }

  return (
    <div
      className="bpb2-wrapper"
      role="progressbar"
      aria-label="Booking journey progress"
      aria-valuenow={visualStep}
      aria-valuemin={1}
      aria-valuemax={TOTAL}
    >
      <div className="bpb2-inner">

        {/* ── Title row ────────────────────────────────── */}
        <div className="bpb2-title-row" key={`${visualStep}-${currentLabel}`}>
          <span className="bpb2-step-title">{currentLabel}</span>
        </div>

        {/* ── Progress bar ─────────────────────────────── */}
        <div className="bpb2-bar-track">
          <Progress
            percent={percent}
            showInfo={false}
            strokeColor={{ '0%': '#006b6d', '100%': '#00b0b3' }}
            trailColor="#e0f2f2"
            strokeWidth={14}
            style={{ margin: 0, display: 'block' }}
          />
        </div>

      </div>
    </div>
  );
};

export default BookingProgressBarV2;
